// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__v5Adu","colCheckbox":"styles_colCheckbox___Lpva"};